import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

const ActivityComp = () => {
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // OData API'den Son Aktiviteleri Çekme
  useEffect(() => {
    const fetchActivities = async () => {
      try {
        // Advert_DeliveryStatus tablosundan son 5 güncellemeyi çekiyoruz. 
        // İlgili kullanıcıyı görmek için $expand=Users ekliyoruz.
        const response = await fetch("https://hiflowapi.stechomeyazilim.info/Advert_DeliveryStatus?$orderby=Created_DateTime desc&$top=5&$expand=Users");
        const result = await response.json();

        if (result && result.value) {
          const formattedData = result.value.map((item, index) => {
            
            // Tarihi "14 Mar" gibi kısa formata çeviriyoruz
            const dateObj = item.Created_DateTime ? new Date(item.Created_DateTime) : new Date();
            const dateStr = dateObj.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' });
            
            // Kullanıcı adı ve durumu ayarlıyoruz
            const userName = item.Users ? item.Users.Users_NameSurname : "Sistem";
            const status = item.Advert_DeliveryStatus_Status || "Güncellendi";
            const advertId = item.Advert_ID || "Bilinmiyor";

            return {
              id: item.ID,
              date: dateStr,
              activity: `${userName}, #${advertId} numaralı taşımanın durumunu güncelledi: ${status}`,
              active: index === 0 // En üstteki aktiviteyi vurgulu (active) yapıyoruz
            };
          });

          setActivities(formattedData);
        }
      } catch (error) {
        console.error("Aktiviteler çekilirken hata oluştu:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchActivities();
  }, []);

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-5">Son Aktiviteler</CardTitle>
          
          {isLoading ? (
            <div className="text-center py-4">
              <Spinner color="primary" size="sm" /> <span className="ms-2">Yükleniyor...</span>
            </div>
          ) : activities.length > 0 ? (
            <ul className="verti-timeline list-unstyled">
              {activities.map((item) => (
                <li className={`event-list ${item.active ? "active" : ""}`} key={item.id}>
                  <div className="event-timeline-dot">
                    <i className={`font-size-18 bx ${item.active ? "bxs-right-arrow-circle bx-fade-right" : "bx-right-arrow-circle"}`} />
                  </div>
                  <div className="flex-shrink-0 d-flex">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item.date}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>{item.activity}</div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-muted text-center py-3">Henüz bir aktivite bulunmuyor.</div>
          )}

          <div className="text-center mt-4">
            <Link to="/gezilerim" className="btn btn-primary waves-effect waves-light btn-sm">
              Tümünü Gör <i className="mdi mdi-arrow-right ms-1" />
            </Link>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default ActivityComp;